import { COMMON_ADJECTIVES, RARE_ADJECTIVES } from '../constants/adjectives';

// Epoch: Puzzle #1 = 2026-03-31
const EPOCH_DATE = new Date('2026-03-31T00:00:00Z');

function mulberry32(seed) {
  return function () {
    seed |= 0;
    seed = (seed + 0x6d2b79f5) | 0;
    let t = Math.imul(seed ^ (seed >>> 15), 1 | seed);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

function hashDateString(dateString) {
  let hash = 0;
  for (let i = 0; i < dateString.length; i++) {
    hash = ((hash << 5) - hash + dateString.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
}

// Shuffle a pool deterministically with a fixed seed (computed once per pool)
function getShuffledPool(pool, shuffleSeed) {
  const rng = mulberry32(shuffleSeed);
  const shuffled = [...pool];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

// Pre-compute shuffled pools (deterministic, fixed seeds — never change these)
const COMMON_SHUFFLED = getShuffledPool(COMMON_ADJECTIVES, 12345);
const RARE_SHUFFLED = getShuffledPool(RARE_ADJECTIVES, 67890);

function getPuzzleNumber(dateString) {
  const date = new Date(dateString + 'T00:00:00Z');
  const diffMs = date - EPOCH_DATE;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  return diffDays + 1;
}


export function generateDailyPuzzle(dateString) {
  const puzzleNum = getPuzzleNumber(dateString) - 1; // 0-indexed

  // Exhaustive cycling: index into shuffled pools, wrapping when exhausted
  // 4 common per puzzle → cycles every COMMON.length/4 puzzles
  // 2 rare per puzzle → cycles every RARE.length/2 puzzles
  const commonStart = (puzzleNum * 4) % COMMON_SHUFFLED.length;
  const rareStart = (puzzleNum * 2) % RARE_SHUFFLED.length;

  const common = [];
  for (let i = 0; i < 4; i++) {
    common.push(COMMON_SHUFFLED[(commonStart + i) % COMMON_SHUFFLED.length]);
  }
  const rare1 = RARE_SHUFFLED[rareStart % RARE_SHUFFLED.length];
  const rare2 = RARE_SHUFFLED[(rareStart + 1) % RARE_SHUFFLED.length];

  // Shuffle row/col assignment with date-based RNG (for variety in positioning)
  const rng = mulberry32(hashDateString(dateString));

  const rowAdjs = [rare1, common[0], common[1]];
  for (let i = rowAdjs.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [rowAdjs[i], rowAdjs[j]] = [rowAdjs[j], rowAdjs[i]];
  }

  const colAdjs = [rare2, common[2], common[3]];
  for (let i = colAdjs.length - 1; i > 0; i--) {
    const j = Math.floor(rng() * (i + 1));
    [colAdjs[i], colAdjs[j]] = [colAdjs[j], colAdjs[i]];
  }

  return {
    rowAdjectives: rowAdjs,
    colAdjectives: colAdjs,
    date: dateString,
    puzzleNumber: getPuzzleNumber(dateString),
  };
}

export function getTodayDateString() {
  const now = new Date();
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York' }).format(now);
}

export function getYesterdayDateString() {
  const now = new Date();
  now.setDate(now.getDate() - 1);
  return new Intl.DateTimeFormat('en-CA', { timeZone: 'America/New_York' }).format(now);
}
